module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/gpda-logo-c68529f9b0722d11208fdb9279d4eb67.svg&quot;;"